/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	RecruiterAvailabilityUpdateRequest,
	RecruiterAvailabilityUpdateResponse,
} from '../types/RecruiterAvailabilityUpdate'

/**
 * PUT /interview-scheduling/availability
 * @see backend/nexus/modules/InterviewScheduling/Http/Controllers/RecruiterAvailabilityController.php RecruiterAvailabilityController::update
 */
export async function recruiterAvailabilityUpdate(
	data: RecruiterAvailabilityUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<RecruiterAvailabilityUpdateResponse>> {
	return axiosInstance.put('/interview-scheduling/availability', data, config)
}
